import { Component, Inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

@Component({
    selector: 'report-viewer-snackbar',
    templateUrl: './report-viewer-snackbar.component.html',
    styleUrls: ['./report-viewer-snackbar.component.less'],
    standalone: false
})
export class ReportViewerSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<ReportViewerSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}
}
